import { forwardRef } from 'react'
import { twMerge } from 'tailwind-merge'

type Props = {
  id: number | string
  name: string
  checked?: boolean
  className?: string
  label: string | React.ReactNode
  value?: string | number | undefined
  disabled?: boolean
  onChange: (val: string | number | undefined) => void
} & Omit<React.ComponentPropsWithoutRef<'input'>, 'id' | 'value' | 'onChange'>

export const Radio = forwardRef<HTMLInputElement, Props>((props: Props, ref: React.Ref<HTMLInputElement>) => {
  const { id, name, checked, label, onChange, disabled, value, className, ...rest } = props
  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    onChange(e.target.value)
  }

  const inputId = `${name}_${id}`

  return (
    <div className={twMerge('flex w-full items-start py-1.5', className, disabled && 'opacity-30')}>
      <div className='relative flex items-center'>
        <input
          defaultChecked={checked}
          id={inputId}
          value={value ?? id}
          name={name}
          type='radio'
          className='form-radio'
          onChange={handleChange}
          ref={ref}
          disabled={disabled}
          aria-label={rest['aria-label'] || (typeof label === 'string' ? label : name)}
          {...rest}
        />
      </div>
      <label htmlFor={inputId} className={twMerge('form-inline-label truncate pl-2.5', disabled ? 'cursor-not-allowed' : 'cursor-pointer')}>
        {label}
      </label>
    </div>
  )
})
